import { FC, useMemo } from "react";
import OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableRow from "../types/order-optimizer-raily-details-hidden-details-heading-tables-order-table-row";
import orderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableHelper from "./order-optimizer-raily-details-hidden-details-heading-tables-order-table.helper";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import OrderOptimizerDetailsTableDotComponent from "../../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import { OrderOptimizerRailyDetailsItemStepsHomeToStart } from "../../../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  detailsStepsHomeToStartItems: OrderOptimizerRailyDetailsItemStepsHomeToStart | null;
};

const OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsHomeToStartItems: OrderOptimizerRailyDetailsItemStepsHomeToStart
  ): OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableRow => {
    const dotColor = "#d9d9d9";

    const index = 0;

    return {
      id: uuidService.generate(),
      value: {
        humanId: (
          <div className="order_optimizer_raily_details_hidden_details_order__humanId">
            <span title={String(index)}>{index}</span>
            <OrderOptimizerDetailsTableDotComponent color={dotColor} />
          </div>
        ),
        address: (
          <div title={detailsStepsHomeToStartItems.displayName}>
            {detailsStepsHomeToStartItems.displayName}
          </div>
        ),
        totalTime: <div />,
        haltingTime: <div />,
        distance: <div />,
      },
    };
  };

  const rows: OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableRow[] =
    useMemo(() => {
      if (!props.detailsStepsHomeToStartItems) return [];

      const orderRows = createTableRow(props.detailsStepsHomeToStartItems);

      return [orderRows];
    }, [props.detailsStepsHomeToStartItems, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
    />
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableComponent;
